import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {},
  actionIcon: {
    color: theme.palette.primary.main,
    height: '14.72px',
    width: '16.36px',
    cursor: 'pointer',
    marginRight: theme.spacing(3.25),
  },
  accountContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: theme.spacing(5),
    marginBottom: theme.spacing(-1),
    marginTop: theme.spacing(-1),
    marginLeft: theme.spacing(-1),
  },
  productNameContainer: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.black.main,
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.secondary.dark,
    fontSize: '13px',
  },
  linkIcon: {
    width: '0.6em !important',
    height: '0.6em !important',
    color: theme.palette.primary.light,
    margin: theme.spacing(0, 0, -0.25, 1),
  },
  awslogo: {
    marginRight: theme.spacing(2.53),
    width: theme.spacing(4.125),
    height: theme.spacing(2.5),
    objectFit: 'contain',
  },
  azurelogo: {
    marginRight: theme.spacing(2.875),
    marginLeft: theme.spacing(1.75),
    width: theme.spacing(3.125),
    height: theme.spacing(3.125),
    objectFit: 'contain',
  },
  gcpLogo: {
    marginRight: theme.spacing(1.625),
    width: theme.spacing(6),
    height: theme.spacing(3.375),
    objectFit: 'contain',
  },
  rowText: {
    color: theme.palette.black.main,
    fontSize: '13px',
  },
  contractLink: {
    textDecoration: 'none',
    color: theme.palette.icon.main,
  },
  contractDisabled: {
    opacity: 0.4,
  },
  actionsContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  container: {
    padding: theme.spacing(4, 4, 0, 4),
  },

  containerAdmin: {
    paddingLeft: 'inherit',
    paddingRight: theme.spacing(4),
    paddingTop: 'inherit',
    paddingBottom: theme.spacing(4),
  },

  badgeContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
  },
  badge: {
    width: '122px',
    padding: theme.spacing(0.5, 1, 0.5, 1.375),
    marginRight: theme.spacing(1.875),
    color: theme.palette.badge.contrastText,
    borderRadius: '4px',
    backgroundColor: theme.palette.badge.main,
    boxSizing: 'border-box',
    fontSize: '12px',
    textTransform: 'uppercase',
    wordBreak: 'break-all',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(-1),
    marginTop: theme.spacing(-1),
    marginLeft: theme.spacing(-1),
  },
  submitButton: {
    marginRight: theme.spacing(3),
  },
  cloudContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 0, 0, 3),
    backgroundColor: theme.palette.bg.main,
    width: 'auto',
  },
  cloudAccountContainer: {
    margin: theme.spacing(3, 0, 3, 3),
    width: theme.spacing(27.5),
  },
}))
